import { Modal, useModalContext } from '../index'
import { Button } from '@highlight/ui'
import { useSignOut } from '@renderer/hooks/use-sign-out'

export const LogoutModal = () => {
  const { close } = useModalContext('logout')

  const { signOut } = useSignOut('Logout modal')

  function handleConfirm() {
    void signOut()
    close()
  }

  return (
    <Modal confirm>
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>Sign Out</Modal.Title>
          <Modal.Description>Are you sure you want to sign out?</Modal.Description>
        </Modal.Header>
        <Modal.Footer>
          <Modal.Close variant="secondary" className="w-full max-w-20">
            Cancel
          </Modal.Close>
          <Button variant="primary" tone="danger" onClick={handleConfirm} className="w-full max-w-20">
            Sign Out
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  )
}
